<div class="p-3">
    <div class="d-flex justify-content-end align-items-center w-100">
        <button type="button" class="close-btn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="mt-2 position-relative">
        <img [src]="imageSrc" alt="Preview" style="width: 100%;">
    </div>
</div>